import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import type { WolverineConfigDto } from '../interfaces/wolverine-config-dto';
import { hostsConfig } from '../utils';

export default abstract class WolverineConfigDao {
  static async getWolverineConfig(env: Environment) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.get<WolverineConfigDto>(
      `${url}/configurations`
    );
    return data;
  }
}
